import getItem from 'owa-mail-store/lib/services/getItem';
import checkIfResponseSuccess from 'owa-mail-store/lib/services/utils/checkIfResponseSuccess';
import ItemInfoResponseMessage from 'owa-service/lib/contract/ItemInfoResponseMessage';
import itemResponseShape from 'owa-service/lib/factory/itemResponseShape';

export default async function getItemIdFromInternetMessageId(
    internetMessageId: string
): Promise<string> {
    const itemShape = itemResponseShape({
        BaseShape: 'IdOnly',
    });

    try {
        const response = await getItem(
            [],
            itemShape,
            null /*shapeName*/,
            null /*requestServerVersion*/,
            null /*options*/,
            internetMessageId
        );
        if (response && checkIfResponseSuccess(response[0])) {
            const responseMessage = response[0] as ItemInfoResponseMessage;
            const updatedItem = responseMessage.Items[0];
            if (updatedItem) {
                return updatedItem.ItemId.Id;
            }
        }
    } catch (e) {}

    return null;
}
